import { useRouter } from "next/router";
import { useCallback } from "react";

export const useBack = () => {
  const router = useRouter();

  const goBack = useCallback(() => {
    if (
      window.history.length <= 1 ||
      ["/review", "/category", "/landing"].some((path) =>
        router.pathname.startsWith(path)
      )
    ) {
      return window.location.replace("/");
    }
    if (
      ["/shopping/[shopId]/voucher", "/payment/succeed/[id]"].includes(
        router.pathname
      )
    ) {
      if (
        router.pathname === "/payment/succeed/[id]" ||
        router.query.success === "true"
      ) {
        return window.history.go((window.history.length - 1) * -1);
      }
      if (window.history.length > 2) {
        return window.history.go(-2);
      }
    }

    return window.history.back();
  }, [router]);

  return { goBack };
};
